export const iconFontAwesomeMapsBomb = (
	<i className="fa-solid fa-bomb"></i>
);
